
export default function Footer() {
  return (
    <>
      {/* Google Maps */}
      <div className="w-full h-96">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.8977!2d-51.9331!3d-23.4205!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ecd0b3c7c7c7c7%3A0x1234567890abcdef!2sAv.%20Sophia%20Rasgulaeff%2C%2094%20-%20Maring%C3%A1%2C%20PR!5e0!3m2!1spt!2sbr!4v1234567890123"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Localização da Clínica ORARE - Dr. Luiz Renato Kreb"
        ></iframe>
      </div>

      {/* Footer */}
      <footer className="bg-[#3A3A3A] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Logo and Tagline */}
            <div className="lg:col-span-1">
              <div className="flex items-center mb-4">
                <span className="text-xl font-bold">Dr. Luiz Renato Kreb</span>
              </div>
              <p className="text-gray-300 leading-relaxed">
                Cirurgia Buco-Maxilo-Facial e Harmonização Orofacial com excelência e humanização.
              </p>
            </div>

            {/* Contact Info */}
            <div className="lg:col-span-1">
              <h3 className="text-lg font-semibold mb-4">Contato</h3>
              <div className="space-y-3">
                <p className="text-gray-300 font-medium">Atende na Clínica ORARE</p>
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-white mt-1 mr-2"></i>
                  <div className="text-gray-300">
                    <p>Av. Sophia Rasgulaeff, 94</p>
                    <p>Maringá - PR</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-white mr-2"></i>
                  <a href="tel:+554430240202" className="text-gray-300 hover:text-white transition-colors">
                    (44) 3026-8859
                  </a>
                </div>
                <div className="flex items-center">
                  <i className="ri-whatsapp-line text-white mr-2"></i>
                  <a href="https://wa.me/5544999297166" className="text-gray-300 hover:text-white transition-colors">
                    (44) 99929-7166
                  </a>
                </div>
                <div className="text-gray-300">
                  <p><strong>Seg–Sex:</strong> 8h30–18h</p>
                  <p><strong>Sáb:</strong> 8h30–12h</p>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div className="lg:col-span-1">
              <h3 className="text-lg font-semibold mb-4">Links Rápidos</h3>
              <ul className="space-y-2">
                <li>
                  <a href="#home" className="text-gray-300 hover:text-white transition-colors">
                    Home
                  </a>
                </li>
                <li>
                  <a href="#sobre" className="text-gray-300 hover:text-white transition-colors">
                    Sobre Dr. Luiz
                  </a>
                </li>
                <li>
                  <a href="#servicos" className="text-gray-300 hover:text-white transition-colors">
                    Serviços
                  </a>
                </li>
                <li>
                  <a href="#resultados" className="text-gray-300 hover:text-white transition-colors">
                    Antes-Depois
                  </a>
                </li>
                <li>
                  <a href="#contato" className="text-gray-300 hover:text-white transition-colors">
                    Contato
                  </a>
                </li>
              </ul>
            </div>

            {/* Social Media */}
            <div className="lg:col-span-1">
              <h3 className="text-lg font-semibold mb-4">Redes Sociais</h3>
              <div className="flex space-x-4">
                <a
                  href="https://www.instagram.com/dr.luizrenatokreb"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-[#6B2432] rounded-full flex items-center justify-center hover:bg-[#5A1E2A] transition-colors"
                >
                  <i className="ri-instagram-fill text-white"></i>
                </a>
                <a
                  href="https://www.facebook.com/dr.luizrenatokreb/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-[#6B2432] rounded-full flex items-center justify-center hover:bg-[#5A1E2A] transition-colors"
                >
                  <i className="ri-facebook-fill text-white"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-600 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="flex flex-wrap items-center space-x-6 mb-4 md:mb-0">
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Política de Privacidade
                </a>
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm">
                  Termos de Uso
                </a>
              </div>
              <p className="text-gray-300 text-sm">
                © 2026 Dr. Luiz Renato Kreb. Todos os direitos reservados.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
